<c-container>
  <div class="d-flex justify-content-between align-items-center mt-5 mb-3">
    <h1>Frequently Asked Questions</h1>

    @if (canEditAnyFaqs) {
      <div class="button-group">
        @if (screenState !== screenStateEnum.ViewAdminAppFaqs) {
          <button mat-raised-button
                  (click)="screenState = screenStateEnum.ViewAdminAppFaqs"
                  data-testid="back-to-view-button">
            Back to View
          </button>
        }

        @if (screenState === screenStateEnum.ViewAdminAppFaqs) {
          <button mat-raised-button
                  color="primary"
                  (click)="screenState = screenStateEnum.ManageGameFaqs"
                  data-testid="manage-faqs-button">
            Manage FAQs
          </button>
        }
      </div>
    }
  </div>

  @switch (screenState) {
    @case (screenStateEnum.ViewAdminAppFaqs) {
      <app-view-frequently-asked-questions></app-view-frequently-asked-questions>
    }
    @case (screenStateEnum.EditFaqs) {
      <app-edit-frequently-asked-questions
        [canEditWebappFaqs]="canEditWebappFaqs"
        [canEditAdminAppFaqs]="canEditAdminAppFaqs">
      </app-edit-frequently-asked-questions>
    }
    @case (screenStateEnum.ManageGameFaqs) {
      <app-manage-game-faqs
        [canEditWebappFaqs]="canEditWebappFaqs"
        [canEditAdminAppFaqs]="canEditAdminAppFaqs">
      </app-manage-game-faqs>
    }
  }
</c-container>
